module.exports = __webpack_public_path__ + "static/media/plus.df81622c.svg";